import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiCalendar,
  FiCoffee,
  FiCompass,
  FiFlag,
  FiHome,
  FiShoppingBag,
} from "react-icons/fi";
import { projectCovers } from "./portfolioData";

const projects = {
  zh: {
    eyebrow: "作品集",
    title: "不同場景，同樣落實到位。",
    intro:
      "服務場景涵蓋地產、零售、餐飲、政企交流與私人宴會。卡片可點開，進入每個項目的細分頁面。",
    cards: [
      {
        slug: "property-campaign",
        code: "POLY",
        label: "地產整合推廣",
        title: "保利房地產集團",
        summary: "佛山及江門 3 個在建樓盤廣告總承包，統籌項目宣傳、物料與執行。",
        tag: "3 個樓盤",
      },
      {
        slug: "brand-activation",
        code: "QIANXI",
        label: "餐飲品牌活動",
        title: "碧桂園 · 千璽機器人",
        summary: "門店廣告及活動策劃，協調品牌呈現與現場落地。",
        tag: "門店活動",
      },
      {
        slug: "retail-planning",
        code: "PLAZA",
        label: "商場活動策劃",
        title: "佛山順德區香繽廣場",
        summary: "商場廣告及活動策劃總承包，兼顧日常宣傳與活動節點執行。",
        tag: "整體承包",
      },
      {
        slug: "government-comms",
        code: "GOV",
        label: "政府宣傳項目",
        title: "政府宣傳與公共資訊",
        summary: "公共宣傳設施、戶外圍牆及室內資訊展示，按不同場景完成設計製作與現場交付。",
        tag: "3 個場景",
      },
      {
        slug: "corporate-private-events",
        code: "150+",
        label: "多場景活動",
        title: "企業及私人活動",
        summary: "年會、宣傳會、酒會、生日會、婚宴及宴會，從方案到現場的完整流程。",
        tag: "150+ 場",
      },
      {
        slug: "business-forums",
        code: "INCUBATE",
        label: "企業孵化與政企交流",
        title: "企業孵化與峰會路演",
        summary: "組織政企對接、園區峰會、企業座談與活動路演，協助企業項目對接與落地。",
        tag: "企業落地",
      },
    ],
  },
  en: {
    eyebrow: "Portfolio",
    title: "Different settings. The same commitment to delivery.",
    intro:
      "Work spanning property, retail, food and beverage, government and business communications, and private celebrations. Every card opens into a focused project page.",
    cards: [
      {
        slug: "property-campaign",
        code: "POLY",
        label: "Property Campaign",
        title: "Poly Real Estate Group",
        summary: "Full advertising contract for three developments in Foshan and Jiangmen, coordinating campaign materials and delivery.",
        tag: "3 developments",
      },
      {
        slug: "brand-activation",
        code: "QIANXI",
        label: "F&B Brand Activation",
        title: "Country Garden · Qianxi Robotics",
        summary: "Store advertising and event planning for the restaurant group, coordinating brand presentation and live execution.",
        tag: "Store activation",
      },
      {
        slug: "retail-planning",
        code: "PLAZA",
        label: "Retail Event Planning",
        title: "Xiangbin Plaza, Shunde",
        summary: "Full advertising and event planning contract covering ongoing promotion and key campaign moments.",
        tag: "Full contract",
      },
      {
        slug: "government-comms",
        code: "GOV",
        label: "Government Communications",
        title: "Government Campaigns & Public Information",
        summary: "Public campaign facilities, outdoor graphics and interior information displays delivered across distinct settings.",
        tag: "3 settings",
      },
      {
        slug: "corporate-private-events",
        code: "150+",
        label: "Multi-format Delivery",
        title: "Corporate & Private Events",
        summary: "Annual galas, promotional events, cocktail parties, birthdays, weddings and banquets delivered end to end.",
        tag: "150+ events",
      },
      {
        slug: "business-forums",
        code: "INCUBATE",
        label: "Business Incubation & Public Affairs",
        title: "Business Incubation & Roadshows",
        summary: "Government liaison, park summits, enterprise forums and roadshows supporting project connections and business landing.",
        tag: "Business landing",
      },
    ],
  },
};

const projectOrder = [
  "corporate-private-events",
  "government-comms",
  "retail-planning",
  "property-campaign",
  "brand-activation",
  "business-forums",
];

const icons = {
  "property-campaign": FiHome,
  "brand-activation": FiCoffee,
  "retail-planning": FiShoppingBag,
  "government-comms": FiFlag,
  "corporate-private-events": FiCalendar,
  "business-forums": FiCompass,
};

function Projects({ language }) {
  const copy = projects[language];
  const orderedCards = projectOrder.map((slug) => copy.cards.find((card) => card.slug === slug));

  return (
    <main className="projects-page">
      <section className="projects-hero site-container">
        <h1>{copy.title}</h1>
        <p>{copy.intro}</p>
      </section>

      <section className="projects-grid site-container">
        {orderedCards.map((card) => {
          const Icon = icons[card.slug];
          return (
            <Link
              to={`/project/${card.slug}`}
              className="project-tile"
              key={card.slug}
            >
              <div className="project-tile__top" data-code={card.code}>
                <img src={projectCovers[card.slug]} alt="" loading="lazy" />
                <Icon aria-hidden="true" />
                <span>{card.code}</span>
                <strong>{card.tag}</strong>
              </div>
              <div className="project-tile__body">
                <p>{card.label}</p>
                <h2>{card.title}</h2>
                <span>{card.summary}</span>
                <div className="project-tile__cta">
                  <span>{language === "zh" ? "開啟細分頁" : "Open detail"}</span>
                  <FiArrowRight aria-hidden="true" />
                </div>
              </div>
            </Link>
          );
        })}
      </section>
    </main>
  );
}

export default Projects;
